module.exports = __webpack_public_path__ + "static/media/rebirth_sample_5.000ac4b0.jpg";